import React, { Component } from 'react';
import { withRouter } from 'react-router';

import categoryTreeQuery from './CategoryTreeQuery.gql';
import { Query } from 'react-apollo';

import CategoryLink from '@jetshop/ui/CategoryLink';

import styled from 'react-emotion';

export const Link = styled(CategoryLink)`
  width: 100%;
  display: block;
  color: #444;
  text-decoration: none;
  line-height: 1.1;
  padding: 5px 0 5px 1rem;

  &:hover {
    color: ${p => p.theme.colors.active};
    text-decoration: underline;
  }
`;

const List = styled('ul')`
  width: 100%;
  &.root > .expanded > ${Link} {
    background: ${({ theme }) => theme.colors.leftaside.category};
    color: #fff;
    border-radius: 3px;
    padding: 2px 10px 2px 1rem;
    line-height: 1.7;
    font-weight: bold;
  }

  margin-bottom: 20px;
`;

const SubList = styled(List)`
  display: none;
  color: #fff;
  margin-bottom: 5px;

  ${Link} + ul {
    font-size: 13px;
  }
`;

const OpenSubButton = styled('span')`
  color: #85919b;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 0.75rem;
  display: block;
  width: 30px;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 1.3rem;
  transition: 0.3s ease-in-out;
  z-index: 1;
`;

const ListItem = styled('li')`
  position: relative;
  width: 100%;
  display: block;
  background: #fff;
  margin: 0.2rem 0;
  padding: 0;
  line-height: 1.7rem;

  &.expanded {
    > ${SubList} {
      display: block;
    }
  }

  &.active {
    > ${Link} {
      font-weight: bold;
      line-height: 1.7;
    }
    li > ul {
      margin-left: 1rem;
    }
  }

  ${OpenSubButton} {
    display: none;
  }
`;

class CategoryTreeBare extends Component {
  data = {};
  times = 0;
  render() {
    const { category, location } = this.props;

    return (
      <Query
        query={categoryTreeQuery}
        variables={{
          rootPath: '/' + location.pathname.split('/')[1],
          currentPath: location.pathname
        }}
        key={location.pathname}
      >
        {({ loading, error, data }) => {
          if (loading || error) {
            return null;
          }

          let { route, rootCategory } = data;

          if (route === undefined || rootCategory === undefined) {
            route = this.data.route;
            rootCategory = this.data.rootCategory;
          } else {
            this.data = {
              route: route,
              rootCategory: rootCategory
            };
          }
          this.times++;
          let selectedCategories = route.parents.map(route => {
            return route.category.id;
          });

          selectedCategories.reverse();

          if (
            category !== undefined &&
            selectedCategories.indexOf(category.id) < 0
          ) {
            selectedCategories.push(category.id);
          }

          return (
            <Tree
              category={rootCategory.data}
              selectedCategories={selectedCategories}
              rootLevel={true}
            />
          );
        }}
      </Query>
    );
  }
}

const CategoryTree = withRouter(CategoryTreeBare);
export default CategoryTree;

export class Tree extends Component {
  render() {
    const { category, selectedCategories, rootLevel } = this.props;
    if (
      category === undefined ||
      category.subcategories === undefined ||
      category.subcategories.length === 0
    ) {
      return null;
    }
    return (
      <List key={category.id} className={rootLevel && 'root'}>
        <TreeItem category={category} selectedCategories={selectedCategories} />
      </List>
    );
  }
}

export class TreeItem extends Component {
  state = {
    subListOpen: false,
    hasBeenSet: false,
    isActive: false
  };

  openSubList(event) {
    this.setState({ subListOpen: !this.state.subListOpen });
  }

  updateState(state) {
    this.setState(state);
  }

  componentWillMount() {
    const { category, selectedCategories } = this.props;
    const isSelected = selectedCategories.indexOf(category.id) > -1;

    if (!this.state.hasBeenSet && isSelected) {
      this.updateState({
        subListOpen: !this.state.subListOpen,
        hasBeenSet: true,
        isActive: true
      });
    }
  }

  componentWillReceiveProps(props) {
    const { category, selectedCategories } = props;
    const isSelected = selectedCategories.indexOf(category.id) > -1;

    if (!this.state.hasBeenSet && isSelected) {
      this.updateState({
        subListOpen: !this.state.subListOpen,
        hasBeenSet: true,
        isActive: true
      });
    }
  }

  render({ category, selectedCategories } = this.props) {
    if (category.name === undefined) {
      // TODO: fetch more
      return null;
    }

    const subCategories =
      category.subcategories &&
      category.subcategories.map(subCategory => {
        return (
          <TreeItem
            category={subCategory}
            selectedCategories={selectedCategories}
            key={subCategory.id}
          />
        );
      });

    const hasSubcategories = subCategories && subCategories.length > 0;

    return (
      <ListItem
        className={
          (this.state.subListOpen ? 'expanded' : '') +
          (this.state.isActive ? ' active' : '')
        }
      >
        {hasSubcategories && (
          <OpenSubButton onClick={() => this.openSubList()}>+</OpenSubButton>
        )}
        <Link category={category}>{category.name}</Link>
        {hasSubcategories && <SubList>{subCategories}</SubList>}
      </ListItem>
    );
  }
}
